import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import Swal from 'sweetalert2'
import axios from 'axios'
import $ from 'jquery'

Vue.use(Vuex)

const Toast = Swal.mixin({
   toast: true,
   position: 'top-end',
   showConfirmButton: false,
   timer: 3500,
   timerProgressBar: true,
   didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
   }
})

export default new Vuex.Store({
   state: {
      urlRest: 'https://acece.oneway.tec.br/Capelania/',
      // urlRest: 'http://192.168.5.192:8080/Capelania-0.0.1/',
      errorOnLoadImg: 'https://cdn.discordapp.com/attachments/795099022439481390/814929467863859221/sem_foto.png',
      isCarregando: false,
      isLogado: false,
      dadosUsuario: {},
      dadosEscola: {},
      tokenSessao: null
   },
   mutations: {
      imageError: (state, e) => {
         e.target.src = state.errorOnLoadImg
      },
      verificarCredenciais: (state, credenciais) => {
         if (localStorage.username != undefined && localStorage.senha != undefined) {
            credenciais = {
               "usuario": localStorage.username.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join(""),
               "senha": localStorage.senha.split(/(\w\w)/g).filter(p => !!p).map(c => String.fromCharCode(parseInt(c, 16))).join("")
            };
         }

         if (credenciais == undefined) {
            return
         } else {
            state.isCarregando = true
         }

         axios({
            method: 'get',
            url: state.urlRest + 'login',
            params: {
               username: credenciais.usuario,
               senha: credenciais.senha
            }
         }).then(function (response) {
            state.dadosUsuario = response.data;
            state.dadosUsuario.usuarioPermissoes = [];
            state.tokenSessao = response.data.tokenSessao;
            state.isLogado = true;

            if (credenciais.manterConectado != false) {
               localStorage.username = credenciais.usuario.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
               localStorage.senha = credenciais.senha.split("").map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("")
            }

            router.push('/escolas')

         }).catch(function (error) {
            localStorage.removeItem('username')
            localStorage.removeItem('senha')

            if (error.response != undefined) {
               if (error.response.status == 401) {
                  Toast.fire({
                     icon: 'error',
                     title: 'Credenciais incorretas!'
                  });
               } else if (error.response.status == 403) {
                  Swal.fire({
                     icon: 'error',
                     title: 'Conta bloqueada!',
                     text: 'Número de tentativas excedido.'
                  });
               } else {
                  Toast.fire({
                     icon: 'error',
                     title: 'Erro: ' + error.response.status
                  });
               }
            } else {
               Toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            state.isCarregando = false
         });
      },
      deslogar: function () {
         if ($('.modal.show').length == 0) {
            localStorage.removeItem('username')
            localStorage.removeItem('senha')
            window.location.reload(true)

         } else {
            $('.modal').modal('hide')

            $(".modal").on('hidden.bs.modal', function () {
               localStorage.removeItem('username')
               localStorage.removeItem('senha')
               window.location.reload(true)
            })
         }
      },
      alterarEscola: function (state) {
         state.dadosEscola = {}
      },
      alternarTelaCarregamento: (state, isCarregando) => {
         state.isCarregando = isCarregando;
      },
      escolaSelecionada: (state, escola) => {
         state.dadosEscola = escola;
         router.push('/paginaInicial')
      },
   },
   actions: {
      imageError: ({ commit }, e) => {
         commit('imageError', e)
      },
      verificarCredenciais: ({ commit }, credenciais) => {
         commit('verificarCredenciais', credenciais)
      },
      alternarTelaCarregamento: ({ commit }, isCarregando) => {
         commit('alternarTelaCarregamento', isCarregando)
      },
      escolaSelecionada: ({ commit }, escola) => {
         commit('escolaSelecionada', escola)
      },
      deslogar: context => context.commit('deslogar'),
      alterarEscola: context => context.commit('alterarEscola'),
   },
   modules: {
   }
})